import React from 'react';
import { closureLineColor } from '../../../constants/colors';
import AdmIntervalChartWrapper from '../adm_shared/AdmIntervalChartWrapper';

export default function AdmClosureIntervalChart(props) {
  const { closure, increment, d0_interval, d2_interval } = props;

  return (
    <AdmIntervalChartWrapper
      title='Defect Closure Prediction'
      closure={closure}
      increment={increment}
      d0_interval={d0_interval}
      d2_interval={d2_interval}
      closureColor={closureLineColor}
      showArrival={false}
      showClosure={true}
    />
  );
}
